import { useState, useEffect } from "react";
import { F, P } from "../../styles/palette";
import { PC, PBack, Bdg } from "../shared";
import usePhotoUpload from "../../hooks/usePhotoUpload";

export default function PPhotos({ nav, patientId }) {
  const { photos, loading, loadPhotos } = usePhotoUpload(patientId);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    if (patientId) loadPhotos();
    // loadPhotos se estabiliza internamente con useCallback en usePhotoUpload
  }, [patientId, loadPhotos]);

  if (!patientId) {
    return (
      <div>
        <PBack nav={nav} />
        <PC>
          <p style={{ color: P.txM, fontSize: 14, textAlign: "center", padding: 16 }}>
            Su cuenta aún no está vinculada a un expediente médico. Consulte con su médico para vincular su cuenta.
          </p>
        </PC>
      </div>
    );
  }

  if (loading) {
    return (
      <div>
        <PBack nav={nav} />
        <p style={{ color: P.txM, fontSize: 13, textAlign: "center", padding: 20 }}>Cargando fotos...</p>
      </div>
    );
  }

  return (
    <div>
      <PBack nav={nav} />
      <h2 style={{ fontSize: 24, color: P.tx, margin: "0 0 6px", fontFamily: "Libre Baskerville, Georgia, serif" }}>
        Mis Fotos de Seguimiento
      </h2>
      <p style={{ color: P.txM, fontSize: 14, margin: "0 0 22px" }}>
        Registro fotográfico clínico de su evolución. Solo visible para usted y su médico.
      </p>

      {photos.length === 0 ? (
        <PC>
          <p style={{ color: P.txM, fontSize: 14, textAlign: "center", padding: 16 }}>
            No hay fotos registradas aún. Se agregarán durante sus sesiones de seguimiento.
          </p>
        </PC>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12 }}>
          {photos.map(photo => {
            const fecha = photo.createdAt?.toDate
              ? photo.createdAt.toDate().toLocaleDateString("es-CO", { day: "numeric", month: "short", year: "numeric" })
              : "—";
            return (
              <div
                key={photo.id}
                onClick={() => setLightbox(photo)}
                style={{ cursor: "pointer", background: "#fff", borderRadius: 12, overflow: "hidden", border: "1px solid #e8e2d9", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                <div style={{ width: "100%", aspectRatio: "4/3", overflow: "hidden", background: "#f1ede7" }}>
                  <img
                    src={photo.url}
                    alt={photo.regionCorporal || "Foto clínica"}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <div style={{ padding: "8px 10px" }}>
                  {photo.regionCorporal && (
                    <Bdg t={photo.regionCorporal} c={P.ac} />
                  )}
                  <p style={{ margin: "5px 0 0", color: P.txM, fontSize: 11, fontFamily: "'JetBrains Mono', monospace" }}>{fecha}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Lightbox */}
      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, overflow: "hidden", maxWidth: 480, width: "100%" }}>
            <img src={lightbox.url} alt={lightbox.regionCorporal || "Foto"} style={{ width: "100%", display: "block" }} />
            <div style={{ padding: "12px 16px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {lightbox.regionCorporal && <Bdg t={lightbox.regionCorporal} c={P.ac} />}
                <span style={{ color: P.txM, fontSize: 11, fontFamily: "'JetBrains Mono', monospace" }}>
                  {lightbox.createdAt?.toDate ? lightbox.createdAt.toDate().toLocaleDateString("es-CO", { year: "numeric", month: "long", day: "numeric" }) : ""}
                </span>
              </div>
              {lightbox.descripcion && (
                <p style={{ margin: "8px 0 0", color: P.tx, fontSize: 13 }}>{lightbox.descripcion}</p>
              )}
              <button
                onClick={() => setLightbox(null)}
                style={{ marginTop: 12, width: "100%", padding: "10px", borderRadius: 8, border: "none", background: P.bdr, color: P.txM, fontSize: 13, cursor: "pointer", fontFamily: F.b }}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
